import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import _ from "lodash";
import React from "react";
import {
    buildHoverList,
    CHIP_AGGREGATION_THRESHOLD,
    useChipFiltersStore,
} from "../BaseChipComponents/chipUtils";

export const DefaultAppliedFilterChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const value = _.get(applicationFiltersStore, props.item.filterKey);
    const rawValue = value?.toString() ?? "";

    const onRemove = () =>
        // @ts-expect-error
        applicationFiltersStore.resetByKey(props.item.filterKey);

    if (typeof value === "string") {
        const values = rawValue
            .split(",")
            .map((v) => v.trim())
            .filter((v) => v.length > 0);

        if (values.length > CHIP_AGGREGATION_THRESHOLD) {
            return (
                <AppliedFilterChip
                    disabled={props.disabled}
                    isApplicable={props.isApplicable}
                    onRemove={onRemove}
                    tooltipContent={buildHoverList(values)}
                >
                    {values.length} {props.item.title}s
                </AppliedFilterChip>
            );
        }
    }

    return (
        <AppliedFilterChip
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={onRemove}
        >
            {props.item.title}: {rawValue}
        </AppliedFilterChip>
    );
});
